module.exports = __webpack_public_path__ + "static/img/penny_pictgrid7_800x726.a1abe1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid7_800x726.jpg
// module id = 9r3u
// module chunks = 0